import React from 'react';
import confirm from '../../utils/confirm';
import Content from '../dashboard/Content';
import alarmService from '../../services/alarm-service';
import sensorService from '../../services/sensor-service';
import { getCurrentUser } from '../../utils/auth';
import SensorItem from '../dashboard/SensorItem';

import './style';

export default class AlarmPage extends React.Component {

  state = {
    alarmedSensors: []
  }

  render() {
    const { alarmedSensors } = this.state;
    return (
      <Content title="نمایش هشدارها">
        <div className="row">
          {alarmedSensors.map((sensor, i) => (
            <SensorItem
              key={i}
              cols="col-xl-3 col-lg-4 col-md-6 col-12"
              sensor={sensor}
              onKillAlarmClicked={this.handleKillAlarmClicked}
              showSettings={true}
            />
          ))}
        </div>
      </Content>
    );
  }

  componentDidMount = async () => {
    await this.refreshAlarmedSensors();
  }

  private refreshAlarmedSensors = async () => {
    try {
      const user = getCurrentUser();
      const alarmedSensors = await sensorService.fetchAlarmedSensor(user._id);
      this.setState({ alarmedSensors });
    }
    catch (e) {
      console.error(e);
    }
  }

  private handleKillAlarmClicked = (sensorId: string) => {
    const dialog = confirm({
      type: 'alert',
      title: 'آیا میخواهید هشدار این سنسور را قطع کنید؟',
      primaryText: 'بله',
      primaryClass: 'ant-btn-danger',
      onSubmit: async () => {
        try {
          await alarmService.killAlarm(sensorId);
          await this.refreshAlarmedSensors();
        }
        catch (e) {
          console.error(e);
        }
      }
    });
    dialog.show();
  }

}
